/**
 * Termín kalendáře zploštělý do tvaru, se kterým pracuje layout pruhu: rozsah dnů, popisek
 * a doprava obou směrů. Vstupem je view model kalendáře (`CalendarEvent`), výstup už žádná
 * doménová rozhodnutí nedělá.
 */
import type { CalendarEvent } from '../calendarModel';
import { dayNumber } from './days';
import { buildTermTransportPlan, type TermTransportPlan } from './transportPlan';

export interface CalendarTermView {
  termId: string;
  /** Popisek pruhu — název produktu; termín bez produktu ve stromu spadne na svůj vlastní název. */
  label: string;
  /** Tooltip pruhu. */
  title: string;
  nights: number;
  /** První den termínu (číslo dne). */
  from: number;
  /** Poslední den termínu včetně (`from + nights`) — jednodenní termín má `to === from`. */
  to: number;
  transport: TermTransportPlan;
  event: CalendarEvent;
}

/**
 * Sestaví termíny pro kalendář. `productNames` mapuje `productId` na název produktu ze stromu —
 * pruh v návrhu nese název produktu, ne název termínu.
 */
export function buildCalendarTerms(
  events: readonly CalendarEvent[],
  productNames: ReadonlyMap<string, string>,
  formatTitle: (event: CalendarEvent, label: string) => string
): CalendarTermView[] {
  return events.map((event) => {
    const label = productNames.get(event.productId) ?? event.name;
    const from = dayNumber(event.start);
    return {
      termId: event.termId,
      label,
      title: formatTitle(event, label),
      nights: event.nights,
      from,
      to: from + event.nights,
      transport: buildTermTransportPlan(event),
      event,
    };
  });
}
